import type { CountryDomain } from '../../../common/constants';
import type { RoleHandoffCountryCode } from '../../../common/hooks/requests/useCreateRoleHandoff';
import { LocationHelper } from '../../../common/LocationHelper';

const roleHandoffCountryCodes: Partial<
  Record<CountryDomain, RoleHandoffCountryCode>
> = {
  id: 'ID',
  my: 'MY',
  sg: 'SG',
  tw: 'TW',
  vn: 'VN',
};

export const getRoleHandoffCountryCode = (country?: CountryDomain | null) =>
  country ? roleHandoffCountryCodes[country] : undefined;

export function submitCandidateRoleHandoff(
  candidateUrl: string,
  code: string,
  countryCode: RoleHandoffCountryCode
) {
  const destination = new URL('/auth/switch-role', candidateUrl);
  destination.searchParams.set('code', code);
  destination.searchParams.set('countryCode', countryCode);
  LocationHelper.assign(destination.toString());
}
